import { render, staticRenderFns } from "./gatewayChoose.vue?vue&type=template&id=e90127a8&scoped=true&"
import script from "./gatewayChoose.vue?vue&type=script&lang=js&"
export * from "./gatewayChoose.vue?vue&type=script&lang=js&"
import style0 from "./gatewayChoose.vue?vue&type=style&index=0&id=e90127a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90127a8",
  null
  
)

export default component.exports